import { createAlertMessageModalActions } from 'react/api/actions/base';

const module = 'RouteSummary';
const alertMessageModal = createAlertMessageModalActions(module);
const missingDriverModal = createAlertMessageModalActions(
  module,
  'missingDriver'
);
const assignDriverModal = createAlertMessageModalActions(
  module,
  'assignDriverModal'
);

export default {
  actions: {
    alertMessageModal: alertMessageModal.actions,
    missingDriverModal: missingDriverModal.actions,
    assignDriverModal: assignDriverModal.actions,
    dispatchAssignDriver: `${module}_DISPATCH_ASSIGN_DRIVER`,
    resetStopCandidate: `${module}_RESET_STOP_CANDIDATE`
  },
  actionCreators: {
    alertMessageModal: alertMessageModal.actionCreators,
    missingDriverModal: missingDriverModal.actionCreators,
    assignDriverModal: assignDriverModal.actionCreators,
    dispatchAssignDriver: (drivers) => ({
      type: `${module}_DISPATCH_ASSIGN_DRIVER`,
      payload: { ...drivers }
    }),
    resetStopCandidate: () => ({
      type: `${module}_RESET_STOP_CANDIDATE`
    })
  }
};
